import React, { useState , useContext,useEffect} from 'react';
import { MaintenanceContext } from '../../MaintenanceContext';
import { UserContext } from '../../UserContext';
import { Button, Card, Row , Col , Image} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import dataForm from './data_form.json'
import Batery from './Batery';
import Brakes from './Brakes';
import Lubricants from './Lubricants';
import Tires from './Tires';
import favicon from '../../assets/favicon.ico'
import Spinner from 'react-bootstrap/Spinner';
import * as Icon from 'react-bootstrap-icons';
function New() {
  const {maintenance,setMaintenance, register} = useContext(MaintenanceContext);
  const [detailForm,setDetailForm] = useState(<></>);
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const data_form = dataForm.data;
  const [user,setUser] = useState({});

  const [smShow, setSmShow] = useState(false);

  const changeForm  = (type) => {

    if(type == 'neumatico'){
        setDetailForm(<Tires key="tires"  id="tires"  props={data_form}/>);
    }else if(type == 'bateria'){
        setDetailForm(<Batery key="batery" id="batery"  props={data_form}/>);
    }else if(type  == 'lubricantes'){
        setDetailForm(<Lubricants key="lubricants" id="lubricants" props={data_form}/>);

    }else if(type == 'frenos'){
        setDetailForm(<Brakes key="brakes" id="brakes" props={data_form}/>);
    }else{
        setDetailForm(<></>);
    }
    setMaintenance({...maintenance, type:type})
  };

  useEffect( () => {




  },[]);


  const maintenanceSave = (event) => {
        const form = event.currentTarget;
        console.log(maintenance);
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        if (form.checkValidity() === false)  {

            return 0;
        }
        //openmodal
        setSmShow(true);
    };


    const saveConfirmModal  = () =>{
        setLoading(true);
        register().then((e) => {
            setLoading(false);
            setSmShow(false);
            changeForm('');
            document.getElementById("formRegister").reset();
            setMaintenance({...maintenance,patente:"",description:""})
            setValidated(false);
        }).catch((err) => {
                setLoading(false);
                console.log(err)
        });
    }


    const spinerRush  =  <Spinner className="align-middle" animation="grow"   variant="dark" role="status">
            <Image rounded width={20} height={20} src={favicon} />
        </Spinner>;
  return (
    <>
        <Modal
        size="sm"
        show={smShow}
        autoFocus={true}
        centered={true}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-sm">
                    Registrar servicio?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col></Col>
                    <Col>
                        {loading && spinerRush}
                    </Col>
                    <Col></Col>
                </Row>
                <Row>
                    <Col></Col>
                    <Col>
                        <Button type='button' onClick={() => setSmShow(false)}  size='md' variant='light'>Volver</Button>
                    </Col>
                    <Col>
                        <Button type='button' size='md' onClick={saveConfirmModal} variant='danger'>Registrar</Button>
                    </Col>
                    <Col></Col>
                </Row>
            </Modal.Body>
        </Modal>

        <Card className="mt-0 ">
            <Card.Body>
                <Form noValidate validated={validated} onSubmit={maintenanceSave} id="formRegister" >
                    <Form.Group className="mb-3" controlId="patent">
                        <Row>
                            <Col md={6} sm={12}>
                                <Form.Label>Patente</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="EXAM-12"
                                    required
                                    value={maintenance.patente}
                                    onChange={(event) => setMaintenance({...maintenance, patente:event.currentTarget.value})}
                                    />

                                <Form.Control.Feedback  type="invalid">
                                    Ingresa una patente válida
                                </Form.Control.Feedback>
                            </Col>
                            <Col md={6} sm={12}>
                                <Form.Label  key="Service_name">Servicios</Form.Label>
                                <Form.Select
                                    aria-label="Seleccione"
                                    required
                                    value={maintenance.type}
                                    onChange={(event) =>changeForm(event.currentTarget.value)}>
                                    <option  key={100} value=''>Seleccione</option>
                                    {
                                        data_form.map((m) => (
                                            <option key={m.option_value} value={m.option_value}>{m.type}</option>
                                        ))
                                    }
                                </Form.Select>
                                <Form.Control.Feedback  type="invalid">
                                    Ingresa un servicio válido
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    </Form.Group>


                    {detailForm}

                    <Form.Group sm="4" className="mb-3"  key="desc" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Descripción</Form.Label>
                            <Form.Control as="textarea" value={maintenance.description}  onChange={(event) => setMaintenance({...maintenance, description:event.currentTarget.value})} rows={3} />
                    </Form.Group>
                    <Row>
                        <Col md={5}></Col>
                        <Col md={4}>
                            <Button type='submit'  size='lg' className='mt-3 mb-3 btn btn-sm btn-block btn-danger'  variant="danger">Registrar Servicio <Icon.Save></Icon.Save></Button>
                        </Col>
                        <Col md={4}></Col>
                    </Row>

                </Form>
            </Card.Body>
        </Card>
    </>


  );


}


export default New;